type SentryClient = ReturnType<typeof import('./sentry').initSentry>

const IDLE_TIMEOUT_MS = 3000

let client: Promise<SentryClient | null> | null = null

function afterPageLoad() {
  return new Promise<void>(resolve => {
    const idle = () =>
      typeof requestIdleCallback === 'function' ? requestIdleCallback(() => resolve(), { timeout: IDLE_TIMEOUT_MS }) : setTimeout(resolve, 1)
    if (document.readyState === 'complete') idle()
    else addEventListener('load', idle, { once: true })
  })
}

export function initMonitoring() {
  if (!import.meta.env.PROD || client) return
  client = afterPageLoad()
    .then(() => import('./sentry'))
    .then(module => module.initSentry())
    .catch(() => null)
}

export function reportError(error: unknown, componentStack?: string | null) {
  void client?.then(sentry => {
    sentry?.captureException(error, componentStack ? { contexts: { react: { componentStack } } } : undefined)
  })
}
